import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

import { themingCssClasses } from '../../mixins/theming-mixin';
  import { recProps } from '../../mixins/rec-component';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-component-collection',
  props: {...recProps()},
  setup(__props) {

  const props = __props;

  const frameCssClass = props.description.framed ? themingCssClasses(['border', 'light_background']) : '';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["components__rec-component-collection", [{ framed: _ctx.description.framed }, _unref(frameCssClass)]])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.description.components, (component) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass([{ distanced: _ctx.description.distanced }, "single-component"]),
        key: component.id
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(component.component), {
          description: component,
          class: _normalizeClass({ 'print--hide': component.print_hide }),
          onSubmit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('submit'))),
          onSubmitAsDraft: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('submit-as-draft')))
        }, null, 40, ["description", "class"]))
      ], 2))
    }), 128))
  ], 2))
}
}

})